import { Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationStart, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';
import { CapitalizePipe } from '../../../../../pipes';
import { DetailsMenuItem } from '../../../../../models';
import { filter } from 'rxjs/operators';
import { ScreenService } from '../../../../../services';
import { RcNavigateDirective } from '../../../../../directives';

@Component({
  selector: 'rc-menu-dropdown',
  standalone: true,
  imports: [
    DropDownListModule,
    CapitalizePipe,
    TranslateModule,
    RouterLinkActive,
    RouterLink,
    NgClass,
    RcNavigateDirective,
  ],
  providers: [RouterLinkActive],
  templateUrl: './menu-dropdown.component.html',
  styleUrl: './menu-dropdown.component.scss',
})
export class MenuDropdownComponent {
  #router = inject(Router);
  #screenService = inject(ScreenService);
  isMobile = computed(() => this.#screenService.isMobile());
  dropdownMenu = input.required<DetailsMenuItem>();
  itemClass = input.required<string>();
  defaultOpen = input<boolean | undefined>();
  opened = signal<boolean | undefined>(undefined);
  hostClass = input<string>('');
  linkClicked = output<void>();
  prefix = computed(() => this.dropdownMenu().url);
  constructor() {
    effect(() => {
      if (this.defaultOpen() === undefined) {
        this.opened.set(true);
      } else {
        this.opened.set(this.defaultOpen());
      }
    });
    this.#router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((e: NavigationStart) => {
      const baseUrl = e.url.split('?')[0].split('#')[0];
      const isInList = this.dropdownMenu()!.items!.findIndex((item) => baseUrl.includes(item.url!)) > -1;
      if (this.defaultOpen() === false) this.opened.set(isInList);
    });
  }

  open() {
    this.opened.set(!this.opened());
  }
}
